export function getEarlyRiskColourClass(ragstatus) {
    if (ragstatus == 1) {
        return "progress-bar-success";
    } else if (ragstatus == 2) {
        return "progress-bar-warning";
    } else if (ragstatus == 3) {
        return "progress-bar-danger";
    }
    return null;
}

export function getEarlyRiskColourName(ragstatus) {
    if (ragstatus == 1) {
        return "Green";
    } else if (ragstatus == 2) {
        return "Amber";
    } else if (ragstatus == 3) {
        return "Red";
    }
    return null;
}

export function getEarlyRiskTooltip(answer) {
    let tooltipContent = [];

    tooltipContent.push(answer.notes);
    if ((answer.answer == answer.questionHelpTextAnswerTrigger) && answer.questionHelpText)
    {
        tooltipContent.push("(" + answer.questionHelpText + ")");
    }
    return {tooltipLines: tooltipContent};
}
